// removed by extract-text-webpack-plugin
module.exports = {"form":"Form--form--3TyUBuLE","buttonContainer":"Form--buttonContainer--1Vv8Xs1j","submitButton":"Form--submitButton--pTpTWorZ"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Form/Form.css
// module id = 1277
// module chunks = 2